import { Button } from 'shared/components/ui';
import React from 'react';
import './PaginadorFacturas.css';

const PaginadorFacturas = ({ page, totalPages, onCambiarPagina }) => {
  if (totalPages <= 1) return null;

  return (
    <nav className="paginador-facturas" aria-label="Paginación de facturas">
      <Button
        className="paginador-btn"
        onClick={() => onCambiarPagina(page - 1)}
        disabled={page === 1}
        aria-label="Página anterior"
      >
        ← Anterior
      </Button>

      <span className="paginador-info">
        Página {page} de {totalPages}
      </span>

      <Button
        className="paginador-btn"
        onClick={() => onCambiarPagina(page + 1)}
        disabled={page === totalPages}
        aria-label="Página siguiente"
      >
        Siguiente →
      </Button>
    </nav>
  );
};

export default PaginadorFacturas;
